import React from 'react';
import IconName from "../../svgLogo/SvgLogo";
import AddComment from "./AddComment";

const Comments = () => {
    return (
        <div className="comments-wrapper">
            <div className="container">
                <div className="title xmb-0 xmb-lg-6">
                    <div className="title-box just-text title-box-blue">
                        <div className="title-bg">
                            <h2 className="text persian-number">
                                112 دیدگاه
                            </h2>
                        </div>
                        <div className="more position-relative d-none d-lg-block">
                            <select className="category-select ct-lg form-select">
                                <option value="1">جدیدترین نظرات</option>
                                <option value="2">مفید ترین نظرات</option>
                                <option value="3">نظر خریداران</option>
                                <option value="4">نظرات منفی</option>
                            </select>
                            <IconName name="expand_more" className="icon position-absolute more-icon"/>
                        </div>
                    </div>
                </div>
                <div className="filter-comment-button d-block d-lg-none xmb-20 d-flex justify-content-center">
                    <div className="select-button position-relative">
                        <select className="category-select ct-lg form-select">
                            <option value="1">جدیدترین نظرات</option>
                            <option value="2">مفید ترین نظرات</option>
                            <option value="3">نظر خریداران</option>
                            <option value="4">نظرات منفی</option>
                        </select>
                        <IconName name="expand_more" className="icon position-absolute more-icon"/>
                    </div>
                    <div className="options-button">
                        <span>فیلتر کردن <IconName name="filter_alt" className="icon"/></span>
                    </div>
                </div>
                <div className="comments-content">
                    <ul className="list-unstyled">
                        <li className="my-comment xmb-8 xmb-lg-10">
                            <div className="row">
                                <div className="col-1 col-lg-2">
                                    <div className="profile-info d-flex">
                                        <div className="img-profile">
                                            <img src="./assets/sample-image/vahid-namvari-gray copy.png"
                                                 alt="profile"/>
                                        </div>
                                        <div className="name-profile d-none d-lg-block">
                                            <span className="name">وحید ناموری</span>
                                            <span className="phone-number persian-number">09904456221</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-11 col-lg-10">
                                    <div className="send-comment xpr-6 xpr-lg-2">
                                        <span className="button" id="add-comment-button">افزودن دیدگاه</span>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li className="other-single-comment xmb-8">
                            <div className="row">
                                <div className="col-lg-3 col-xl-2">
                                    <div className="profile-info d-flex">
                                        <div className="img-profile">
                                            <img src="./assets/sample-image/Ellipse 126.png"
                                                 alt="profile"/>
                                        </div>
                                        <div className="name-profile">
                                            <span className="name">علی یزدانی حمزه لوی</span>
                                            <span className="date-buy persian-number">۱۸ تیر ۱۳۹۹</span>
                                            <span className="status-product"><IconName name="verified_user"
                                                                                       className="icon"/> خریدار محصول </span>
                                            <span className="store-name">فورشگاه موبایل آذربایجان</span>
                                            <div className="star-rating d-block d-lg-none" star-score={4}>
                                                <IconName name="star" className="icon"/>
                                                <IconName name="star" className="icon"/>
                                                <IconName name="star" className="icon"/>
                                                <IconName name="star" className="icon"/>
                                                <IconName name="star" className="icon"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-9 col-xl-10">
                                    <div className="text-comment xmb-4">
                                        <p className="text xm-0">من خیلی راضیم کمتر از ۱ هفته است گرفتم ولی رفته رفته
                                            دارم
                                            عاشقش میشم و از خریدم راضی هستم
                                            فقط موقع خریدش حتما ضد خوش صفحه رو تهیه کنید چون من دیرتر سفارش دادم تا
                                            برسه
                                            دستم خط افتاد صفحه اش متاسفانه</p>
                                    </div>
                                    <div className="score-comment d-flex justify-content-between">
                                        <div className="score d-flex align-items-center">
                                            <span className="question">آیا این نظر برایتان مفید بود؟</span>
                                            <span className="yes persian-number">بله <span
                                                className="number-yes">(۱۹۱)</span></span>
                                            <span className="no persian-number">خیر <span
                                                className="number-no">(۲۹)</span></span>
                                            <div className="star-rating d-none d-lg-block" star-score={4}>
                                                <IconName name="star" className="icon"/>
                                                <IconName name="star" className="icon"/>
                                                <IconName name="star" className="icon"/>
                                                <IconName name="star" className="icon"/>
                                                <IconName name="star" className="icon"/>
                                            </div>
                                        </div>
                                        <div className="response">
                                            <span>پاسخ</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li className="advanced-comment xmt-14 xmt-lg-0 xpb-0 xpb-lg-20">
                            <div className="row">
                                <div className="col-lg-3 col-xl-2">
                                    <div className="profile-info d-flex">
                                        <div className="img-profile">
                                            <img src="./assets/sample-image/Ellipse 121.png"
                                                 alt="profile"/>
                                        </div>
                                        <div className="name-profile">
                                            <span className="name">آرزو سلیمانی</span>
                                            <span className="date-buy persian-number">حدود ۲ ساعت پیش</span>
                                            <span className="status-product ok-product"><IconName name="thumb_up"
                                                                                                  className="icon"/>خریدارم، توصیه می‌کنم</span>
                                            <div className="star-rating d-block d-lg-none" star-score={5}>
                                                <IconName name="star" className="icon"/>
                                                <IconName name="star" className="icon"/>
                                                <IconName name="star" className="icon"/>
                                                <IconName name="star" className="icon"/>
                                                <IconName name="star" className="icon"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-9 col-xl-10">
                                    <div className="text-comment">
                                        <p className="text xm-0">
                                            من الان سه ماهه سامسونگ داشتم عوض کردم اینو خریدم یعنی تا امروز هرروز یدونه
                                            امکانات جدیدشو میبینم و کیفیت و سرعتش حرف نداره … گیم بوتر داره که رم رو از
                                            هر لحاظ به نحو صحیح عمل میکنه ـ. کیفیت گرافیکی عالی … دوربیناش فوق العاده
                                            خوب … لمس و تاچ و نرم افزاری که حرف نداره … هر هفته هم یه نوع آپدیت میاد
                                            برات که بروز میکنه و امکانات اضافه میشه یعنی انگا داری هر هفته یه گوشی مدل
                                            بالاشو میخری
                                        </p>
                                    </div>
                                    <div className="points-comment xmt-6">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="good-points">
                                                    <div className="title xmb-4"><span>نقاط قوت</span></div>
                                                    <div className="list-points">
                                                        <ul className="list-unstyled">
                                                            <li><span>نمایشگر بزرگ 12.9 اینچی باکیفیت خیره‌کننده</span>
                                                            </li>
                                                            <li><span>مجهز به چهار اسپیکر باکیفیت</span></li>
                                                            <li><span>پردازنده‌ی بسیار قدرتمند</span></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 xmt-4 xmt-lg-0">
                                                <div className="bad-points">
                                                    <div className="title xmb-4"><span>نقاط ضعف</span></div>
                                                    <div className="list-points">
                                                        <ul className="list-unstyled">
                                                            <li><span>عدم تعادل مناسب دستگاه در هنگام تایپ با کیبورد فیزیکی</span>
                                                            </li>
                                                            <li><span>قیمت زیاد</span></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="score-comment xmt-4 d-flex justify-content-between">
                                        <div className="score d-flex align-items-center">
                                            <span className="question">آیا این نظر برایتان مفید بود؟</span>
                                            <span className="yes persian-number">بله <span
                                                className="number-yes">(۱۹۱)</span></span>
                                            <span className="no persian-number">خیر <span
                                                className="number-no">(۲۹)</span></span>
                                            <div className="star-rating d-none d-lg-block" star-score={5}>
                                                <IconName name="star" className="icon"/>
                                                <IconName name="star" className="icon"/>
                                                <IconName name="star" className="icon"/>
                                                <IconName name="star" className="icon"/>
                                                <IconName name="star" className="icon"/>
                                            </div>
                                        </div>
                                        <div className="response">
                                            <span>پاسخ</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="sayman-response xmt-10">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div
                                            className="sayman-profile d-flex justify-content-start justify-content-lg-center xmb-4 xmb-lg-0">
                                            <div className="img-profile">
                                                <img src="./assets/sample-image/sayman-app.png"
                                                     alt="profile"/>
                                            </div>
                                            <div className="name-profile">
                                                <span className="name">سایمان دیجیتال </span>
                                                <span className="date-buy persian-number">حدود ۲ ساعت پیش</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-8">
                                        <div className="sayman-comment">
                                            <div className="text-comment">
                                                <p className="text xm-0">
                                                    ی مقدار هنگی داره بعد چند ماه استفاده بخصوص من پابجی بازی میکنم
                                                    گاهی
                                                    وسطش چن ثانیه هنگ داره ولی عجیب این که صفحه جوشی و پشتش داغ
                                                    نمیکنه
                                                    ینی اوندی گرم نمیشه ک حس کنی ب اون صورت نامحسوسه در کل
                                                </p>
                                            </div>
                                            <div className="score-comment xmt-4 d-flex justify-content-between">
                                                <div className="score d-flex align-items-center">
                                                    <span className="question">آیا این نظر برایتان مفید بود؟</span>
                                                    <span className="yes persian-number">بله <span
                                                        className="number-yes">(۱۹۱)</span></span>
                                                    <span className="no persian-number">خیر <span
                                                        className="number-no">(۲۹)</span></span>
                                                    <div className="star-rating d-none d-lg-block" star-score={2}>
                                                        <IconName name="star" className="icon"/>
                                                        <IconName name="star" className="icon"/>
                                                        <IconName name="star" className="icon"/>
                                                        <IconName name="star" className="icon"/>
                                                        <IconName name="star" className="icon"/>
                                                    </div>
                                                </div>
                                                <div className="response">
                                                    <span>پاسخ</span>
                                                </div>
                                            </div>
                                            <div className="send-comment position-relative xmt-10 d-none d-lg-block">
                                                <input type="text" placeholder="دیدگاه خود را وارد کنید…"
                                                       className="form-control"/>
                                                <span className="send position-absolute"><IconName name="arrow_forward"
                                                                                                   className="icon"/></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li className="other-single-comment no-product xmb-14 xmt-10 xmt-lg-0">
                            <div className="row">
                                <div className="col-lg-3 col-xl-2">
                                    <div className="profile-info d-flex">
                                        <div className="img-profile">
                                            <img src="./assets/sample-image/Ellipse 126.png"
                                                 alt="profile"/>
                                        </div>
                                        <div className="name-profile">
                                            <span className="name">علی یزدانی حمزه لوی</span>
                                            <span className="date-buy persian-number">۱۸ تیر ۱۳۹۹</span>
                                            <span className="status-product"><IconName name="thumb_down"
                                                                                       className="icon"/> خریدارم، توصیه نمی‌کنم </span>
                                            <div className="star-rating d-block d-lg-none" star-score={4}>
                                                <IconName name="star" className="icon"/>
                                                <IconName name="star" className="icon"/>
                                                <IconName name="star" className="icon"/>
                                                <IconName name="star" className="icon"/>
                                                <IconName name="star" className="icon"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-9 col-xl-10">
                                    <div className="text-comment xmb-4">
                                        <p className="text xm-0">من خیلی راضیم کمتر از ۱ هفته است گرفتم ولی رفته رفته
                                            دارم عاشقش میشم و از خریدم راضی هستم
                                            فقط موقع خریدش حتما ضد خوش صفحه رو تهیه کنید چون من دیرتر سفارش دادم تا برسه
                                            دستم خط افتاد صفحه اش متاسفانه</p>
                                    </div>
                                    <div className="score-comment d-flex justify-content-between">
                                        <div className="score d-flex align-items-center">
                                            <span className="question">آیا این نظر برایتان مفید بود؟</span>
                                            <span className="yes persian-number">بله <span
                                                className="number-yes">(۱۹۱)</span></span>
                                            <span className="no persian-number">خیر <span
                                                className="number-no">(۲۹)</span></span>
                                            <div className="star-rating d-none d-lg-block" star-score={4}>
                                                <IconName name="star" className="icon"/>
                                                <IconName name="star" className="icon"/>
                                                <IconName name="star" className="icon"/>
                                                <IconName name="star" className="icon"/>
                                                <IconName name="star" className="icon"/>
                                            </div>
                                        </div>
                                        <div className="response">
                                            <span>پاسخ</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="pagination-wrapper d-flex justify-content-center align-content-center xmt-16">
                    <nav aria-label="Page navigation example">
                        <ul className="pagination persian-number xm-0">
                            <li className="page-item active"><a className="page-link" href="#">1</a></li>
                            <li className="page-item"><a className="page-link" href="#">2</a></li>
                            <li className="page-item"><a className="page-link" href="#">3</a></li>
                            <li className="page-item">
                                <a className="page-link" href="#" aria-label="Next">
                                    <span aria-hidden="true"><IconName name="last_page" className="icon"/></span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            <AddComment/>
        </div>
    );
};

export default Comments;
